import {
  Box,
  Button,
  Grid,
  Typography,
  Skeleton,
  Paper,
  IconButton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import BreadCrumbHeader from "./BreadCrumbHeader";
import { allNotification } from "redux/action/Notification/getNotifications";
import { useSelector, useDispatch } from "react-redux";
import useGetLoggedInUser from "services/hooks/LoggedInUser/useGetLoggedInUser";
import Avatargenerator from "../AvatarGenerator";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import { styled } from "@mui/material/styles";
import Nodatafound from "../../components/NoDataFound/NoDataFound";
import sendEvents from "utils/sendEvents.js";
import { getProductDetailPath } from "utils/productDetailPath";
import { goToListingApp } from "utils/listingAppUrl";
import { getNotificationTab } from "utils/notificationTab";
import {
  fetchNotificationTabCounts,
  formatBadgeCount,
  formatNotificationReceivedAt,
} from "utils/notificationCounts";
import useGetAuthUser from "services/hooks/LoggedInUser/useGetAuthUser.js";

// Styled Components for Modern UI
const StyledPagination = styled(Pagination)(({ theme }) => ({
  "& .MuiPagination-ul": {
    justifyContent: "center",
    gap: "10px",
  },
  "& .MuiPaginationItem-root": {
    fontFamily: '"Google Sans Flex", "Inter", sans-serif',
    fontSize: "13px",
    fontWeight: 500,
    color: "#64748b",
    minWidth: "38px",
    height: "38px",
    borderRadius: "999px",
    border: "1px solid rgba(33, 34, 38, 0.08)",
    transition: "all 220ms cubic-bezier(0.22, 1, 0.36, 1)",
    "&.Mui-selected": {
      backgroundColor: "#2261a2",
      color: "#FFFFFF",
      fontWeight: 500,
      "&:hover": {
        backgroundColor: "#2261a2",
      },
    },
    "&:hover": {
      backgroundColor: "rgba(183, 191, 217, 0.1)",
      color: "#2261a2",
    },
    "&:focus-visible": {
      outline: "2px solid #2563eb",
      outlineOffset: "2px",
    },
    "&:active": {
      transform: "translateY(1px)",
    },
  },
  "& .MuiPaginationItem-icon": {
    color: "#2261a2",
    fontSize: "18px",
  },
}));

const NotificationCard = styled(Paper)(({ theme }) => ({
  padding: "16px 18px",
  borderRadius: "20px",
  backgroundColor: "rgba(183, 191, 217, 0.1)",
  border: "1px solid rgba(33, 34, 38, 0.06)",
  boxShadow: "0 6px 24px rgba(18, 19, 23, 0.04)",
  transition: "all 220ms cubic-bezier(0.22, 1, 0.36, 1)",
  "&:hover": {
    boxShadow: "0 10px 26px rgba(18, 19, 23, 0.08)",
    borderColor: "rgba(18, 19, 23, 0.12)",
    transform: "translateY(-1px)",
  },
  "@media (prefers-reduced-motion: reduce)": {
    transition: "none",
    "&:hover": {
      transform: "none",
    },
  },
}));

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "active",
})(({ active }) => ({
  fontFamily: '"Google Sans Flex", "Inter", sans-serif',
  fontWeight: 500,
  fontSize: "13px",
  textTransform: "none",
  borderRadius: "999px",
  padding: "9px 18px",
  minWidth: "92px",
  border: `1px solid ${active ? "#2261a2" : "rgba(33, 34, 38, 0.08)"}`,
  color: active ? "#FFFFFF" : "#64748b",
  backgroundColor: active ? "#2261a2" : "#FFFFFF",
  transition: "all 220ms cubic-bezier(0.22, 1, 0.36, 1)",
  "@media (max-width: 599.95px)": {
    flex: "1 1 calc(50% - 8px)",
    minWidth: 0,
    width: "calc(50% - 8px)",
    justifyContent: "center",
    padding: "8px 12px",
    fontSize: "12px",
  },
  "&:hover": {
    borderColor: "#2261a2",
    color: active ? "#FFFFFF" : "#2261a2",
    backgroundColor: active ? "#2261a2" : "rgba(183, 191, 217, 0.1)",
    transform: "translateY(-1px)",
    boxShadow: "0 6px 20px rgba(18, 19, 23, 0.08)",
  },
  "&:active": {
    transform: "translateY(1px)",
  },
  "&:focus-visible": {
    outline: "2px solid #2563eb",
    outlineOffset: "2px",
  },
  "& .notification-count-badge": {
    backgroundColor: active
      ? "rgba(255, 255, 255, 0.22)"
      : "rgba(183, 191, 217, 0.24)",
    color: active ? "#FFFFFF" : "#2261a2",
    border: active
      ? "1px solid rgba(255, 255, 255, 0.36)"
      : "1px solid rgba(34, 97, 162, 0.14)",
  },
}));

const FullscreenNotification = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: loggedInUserData } = useGetLoggedInUser();
  const { getNotification } = useSelector((state) => state.allNotifications);
  const { data: AuthUserData } = useGetAuthUser();

  const [active, setActive] = useState(
    AuthUserData?.data?.superAdmin ? "btn1" : "btn2",
  );
  const [btn1, setBtn1] = useState(active === "btn1");
  const [btn2, setBtn2] = useState(active === "btn2");
  const [btn3, setBtn3] = useState(active === "btn3");
  const [btn4, setBtn4] = useState(active === "btn4");
  const [btn5, setBtn5] = useState(active === "btn5");
  const [totalCountBXIArray, SetTotalCountBXIArray] = useState([]);
  const [totalCountBuyerArray, setTotalCountBuyerArray] = useState([]);
  const [totalCountSellerArray, setTotalCountSellerArray] = useState([]);
  const [readNotifications, setReadNotifications] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [btns, setBtns] = useState([]);
  const [unReadCountOfAll, setUnReadCountOfAll] = useState(0);
  const [unReadCountOfBxi, setUnReadCountOfBxi] = useState(0);
  const [unReadCountOfBuyer, setUnReadCountOfBuyer] = useState(0);
  const [unReadCountOfSeller, setUnReadCountOfSeller] = useState(0);
  const [readCount, setReadCount] = useState(0);
  const [serverPage, setServerPage] = useState(1);
  const [serverTotalPages, setServerTotalPages] = useState(1);
  const SERVER_PAGE_SIZE = 80;
  const MAX_NOTIFICATIONS_RENDER = 500;
  const getSafeMessage = (item) =>
    String(item?.message || item?.body || item?.title || "");
  // A v2 notification carries an authored `title` (the headline the copy was
  // written as) and a `body` (the supporting line). Every surface rendered only
  // `message` — which the fetch layer collapses to body||title — so the headline
  // was dropped and the bell showed the terser body instead of the notification
  // as authored. The legacy `type` field, used as the heading, does not exist on
  // v2 rows at all, so that heading rendered blank.
  const getSafeTitle = (item) =>
    String(item?.title || item?.type || "");
  const getSafeBody = (item) => {
    const body = String(item?.body || item?.message || "");
    return body === getSafeTitle(item) ? "" : body;
  };

  const login_User = loggedInUserData?.data?._id;
  const login_Company =
    loggedInUserData?.data?.companyId?._id ||
    loggedInUserData?.data?.companyId ||
    "";
  const primaryReceiverId = login_Company || login_User || "";
  const fallbackReceiverId =
    login_Company && login_User
      ? primaryReceiverId === login_Company
        ? login_User
        : login_Company
      : "";
  useEffect(() => {
    if (primaryReceiverId) {
      dispatch(
        allNotification(primaryReceiverId, "", {
          page: serverPage,
          limit: SERVER_PAGE_SIZE,
          receiverId: primaryReceiverId,
          fallbackReceiverId,
        }),
      );
    }
  }, [dispatch, primaryReceiverId, fallbackReceiverId, serverPage]);

  useEffect(() => {
    if (
      !getNotification ||
      typeof getNotification !== "object" ||
      Array.isArray(getNotification)
    ) {
      return;
    }
    setServerTotalPages(Number(getNotification?.pagination?.totalPages || 1));
    const incoming = Array.isArray(getNotification?.notifications)
      ? getNotification.notifications
      : [];
    setNotifications(incoming.slice(0, MAX_NOTIFICATIONS_RENDER));
  }, [getNotification]);

  useEffect(() => {
    const bounded = Array.isArray(notifications) ? notifications : [];

    // Tab lists for the current page (filtering the feed). Badge numbers come
    // from fetchNotificationTabCounts (full unread totals), not this page slice.
    const bxiList = [];
    const purchaseList = [];
    const sellList = [];
    bounded.forEach((item) => {
      const tab = getNotificationTab(item);
      if (tab === "purchase") {
        purchaseList.push(item);
      } else if (tab === "sell") {
        sellList.push(item);
      } else {
        bxiList.push(item);
      }
    });

    SetTotalCountBXIArray(bxiList);
    setTotalCountBuyerArray(purchaseList);
    setTotalCountSellerArray(sellList);
  }, [notifications]);

  // Read tab must not filter the current All page — read rows are often older
  // than page 1, which left the badge at 1 and the list empty. Load status=READ.
  useEffect(() => {
    if (!btn5 || !primaryReceiverId) return undefined;
    let active = true;
    (async () => {
      try {
        const buildUrl = (receiverId) =>
          `v2/notifications?page=1&pageSize=${SERVER_PAGE_SIZE}&status=READ&receiverId=${encodeURIComponent(
            receiverId,
          )}`;
        let { data } = await axios.get(buildUrl(primaryReceiverId), {
          withCredentials: true,
        });
        let items = Array.isArray(data?.data?.items) ? data.data.items : [];
        if (
          items.length === 0 &&
          fallbackReceiverId &&
          fallbackReceiverId !== primaryReceiverId
        ) {
          const fallback = await axios.get(buildUrl(fallbackReceiverId), {
            withCredentials: true,
          });
          data = fallback?.data;
          items = Array.isArray(data?.data?.items) ? data.data.items : [];
        }
        if (!active) return;
        setReadNotifications(
          items.map((item) => ({
            ...item,
            message: item?.body || item?.title || "",
            read: true,
          })),
        );
        const total = Number(data?.data?.total);
        if (Number.isFinite(total)) setReadCount(total);
      } catch (_) {
        if (active) setReadNotifications([]);
      }
    })();
    return () => {
      active = false;
    };
  }, [
    btn5,
    primaryReceiverId,
    fallbackReceiverId,
    getNotification?.unreadCount,
  ]);

  const refreshTabCounts = React.useCallback(async () => {
    if (!primaryReceiverId) return;
    try {
      const counts = await fetchNotificationTabCounts(primaryReceiverId);
      setUnReadCountOfAll(counts.unreadAll);
      setUnReadCountOfBxi(counts.unreadBxi);
      setUnReadCountOfBuyer(counts.unreadPurchase);
      setUnReadCountOfSeller(counts.unreadSell);
      setReadCount(counts.readCount);
    } catch (err) {
      // Keep last known badge values on count-fetch failure.
    }
  }, [primaryReceiverId]);

  useEffect(() => {
    refreshTabCounts();
  }, [refreshTabCounts, getNotification?.unreadCount]);

  const {
    data: userData,
  } = useGetLoggedInUser();

  const resolveMarkReceiverId = (data) =>
    String(data?.receiverId || primaryReceiverId || fallbackReceiverId || "");

  const refreshNotifications = () => {
    if (!primaryReceiverId) return;
    dispatch(
      allNotification(primaryReceiverId, "", {
        page: serverPage,
        limit: SERVER_PAGE_SIZE,
        receiverId: primaryReceiverId,
        fallbackReceiverId,
      }),
    );
  };

  const UpdateNotifications = async (data, { forceRead } = {}) => {
    const nextRead =
      typeof forceRead === "boolean" ? forceRead : data?.read !== true;
    // Already in the desired state (e.g. click-through on an already-read row).
    if (Boolean(data?.read) === nextRead) return;

    const markReceiverId = resolveMarkReceiverId(data);
    const tab = getNotificationTab(data);

    // Optimistic local + badge update so counters drop before navigation/refetch.
    setNotifications((prev) =>
      prev.map((item) =>
        String(item?._id) === String(data?._id)
          ? {
            ...item,
            read: nextRead,
            readAt: nextRead ? new Date().toISOString() : null,
            status: nextRead ? "READ" : "SENT",
          }
          : item,
      ),
    );
    const delta = nextRead ? -1 : 1;
    setUnReadCountOfAll((n) => Math.max(0, (Number(n) || 0) + delta));
    if (tab === "purchase") {
      setUnReadCountOfBuyer((n) => Math.max(0, (Number(n) || 0) + delta));
    } else if (tab === "sell") {
      setUnReadCountOfSeller((n) => Math.max(0, (Number(n) || 0) + delta));
    } else {
      setUnReadCountOfBxi((n) => Math.max(0, (Number(n) || 0) + delta));
    }
    setReadCount((n) => Math.max(0, (Number(n) || 0) + (nextRead ? 1 : -1)));

    try {
      await axios.patch(
        `v2/notifications/${data._id}/read?receiverId=${encodeURIComponent(markReceiverId)}`,
        { read: nextRead },
        { withCredentials: true },
      );
      refreshNotifications();
      refreshTabCounts();
    } catch (err) {
      refreshNotifications();
      refreshTabCounts();
    }
  };

  const DeleteNotifications = async (id) => {
    const target = notifications.find((n) => String(n?._id) === String(id));
    const markReceiverId = resolveMarkReceiverId(target);
    setNotifications((prev) =>
      prev.filter((item) => String(item?._id) !== String(id)),
    );
    try {
      await axios.delete(
        `v2/notifications/${id}?receiverId=${encodeURIComponent(markReceiverId)}`,
        { withCredentials: true },
      );
    } catch (err) {
      // still refresh so UI stays truthful
    }
    refreshNotifications();
    refreshTabCounts();
  };

  /**
   * Open whatever a notification is about.
   *
   * Legacy notifications carry only a message, so the chain below infers the
   * destination from its wording. Notifications from the v2 pipeline carry an
   * `eventKey` and a server-resolved `redirectPath`, so they are routed from
   * that instead — matching their wording against the legacy phrases would
   * fail and the click would silently do nothing.
   */
  const handleNotificationClick = (notification) => {
    // Opening a notification counts as reading it (same as inbox apps).
    if (notification?.read !== true) {
      UpdateNotifications(notification, { forceRead: true });
    }

    const eventKey = notification?.eventKey || "";

    if (eventKey) {
      // Listing pages live in the seller-hub app, reached through a signed
      // handoff rather than a path.
      if (/^(BW_LISTING|USER_LISTING)\./.test(eventKey)) {
        goToListingApp({ source: "dashboard" });
        return;
      }
      const target = notification?.redirectPath || "";
      // Only follow in-app paths; anything else (the BXI-admin routes) is not
      // ours to navigate to.
      if (target.startsWith("/") && !target.startsWith("/BXI-admin")) {
        navigate(target);
        return;
      }
    }

    handleClickRedirect(getSafeMessage(notification));
  };

  const handleClickRedirect = (message) => {
    if (message.includes("messages")) {
      navigate("/home/message");
    } else if (message.includes("contacted")) {
      navigate("/home/message");
    } else if (
      message?.includes("approved by our team") ||
      message?.includes(
        "Attention! You have successfully uploaded your product",
      ) ||
      message?.includes("disapproved by our team")
    ) {
      const productIdRegex = /productId\s*:\s*(\w+)/;
      const match = message.match(productIdRegex);

      let productId = null;
      if (match && match[1]) {
        productId = match[1];
      }

      const productTypeMatch = message.match(/productType:(\w+)/);

      let productType;
      if (productTypeMatch) {
        productType = productTypeMatch[1];
      }

      if (productId && productType === "Product") {
        navigate(
          getProductDetailPath({ _id: productId, ListingType: "Product" }),
        );
      } else if (productId && productType === "Media") {
        navigate(
          getProductDetailPath({ _id: productId, ListingType: "Media" }),
        );
      } else if (productId && productType === "Voucher") {
        navigate(
          getProductDetailPath({ _id: productId, ListingType: "Voucher" }),
        );
      }
    } else if (message.includes("rejected")) {
      navigate("/home/order-requests", {
        state: {
          tab: "Sold",
        },
      });
    } else if (message.includes("has confirmed delivery")) {
      navigate("/home/order-requests", { state: { tab: "Sold" } });
    } else if (
      message.includes("better benefits!") ||
      message.includes("Profile now to")
    ) {
      navigate("/home/planpricing");
    } else if (message.includes("PI generated by you has been confirmed")) {
      navigate("/home/sellerpilist");
    } else if (message.includes("successfully uploaded your product")) {
      goToListingApp({ source: "dashboard" });
    } else if (
      message.includes("E-invoice for order") ||
      message.includes(" for E-invoice of you recent order")
    ) {
      navigate("/home/myorderlist");
    } else if (
      message.includes("has generated PI for Order Id") ||
      message.includes("Proforma Invoice") ||
      message.includes("Attention! PI for the order id") ||
      message.includes("Proforma Invoice (PI) for Order id") ||
      message.includes("has been accepted by the Buyer and payment is done.") ||
      message.includes(
        "Attention! Your Proforma Invoice has been rejected by the Buyer.",
      )
    ) {
      const productIdRegex = /piid\s*:\s*(\w+)/;
      const match = message.match(productIdRegex);

      let piId = null;
      if (match && match[1]) {
        piId = match[1];
      }

      if (piId) {
        navigate(`/home/performainvoice/${piId}`);
      }
    } else if (
      message.includes("item") ||
      message.includes("shipment") ||
      message.includes("picked") ||
      message.includes("delivery") ||
      message.includes("AWB")
    ) {
      navigate("/home/trackorders");
    } else if (message.includes("Price And Quantity")) {
      goToListingApp({ source: "dashboard" });
    } else if (message.includes("Debited") || message.includes("recovered")) {
      navigate("/home/dashboard");
    } else if (message.includes("credit") || message.includes("Credit")) {
      // @deprecated Feb 2026: Credit status page removed, redirect to dashboard
      navigate("/home/dashboard");
    } else if (message.includes("Credited") || message.includes("Balance")) {
      navigate("/home/dashboard");
    } else if (message.includes("delivered")) {
      navigate("/home/myorderlist");
    } else if (message.includes("reviewed & approved by our team.")) {
      goToListingApp({ source: "dashboard" });
    } else if (message.includes("Complete your Profile")) {
      navigate("/home/profile");
    } else if (
      message.includes("PO for your product has been generated") ||
      message.includes("Attention! PO for the order id") ||
      message.includes("Purchase Order (PO) for Order Id") ||
      message.includes("has been partially accepted by the")
    ) {
      const productIdRegex = /poid\s*:\s*(\w+)/;
      const match = message.match(productIdRegex);

      let poId = null;
      if (match && match[1]) {
        poId = match[1];
      }

      if (poId) {
        navigate(`/home/sellerdetailedordersummary/${poId}`);
      }
    } else if (
      message?.includes(
        "about to expire within 28 days and it will be delisted soon",
      ) ||
      message?.includes("is about to be delisted in 14 days")
    ) {
      goToListingApp({ source: "dashboard", tab: "Delist" });
    } else if (
      message.includes(
        "Attention! We have suggested some changes to your product, uploaded on BXI Marketplace.",
      )
    ) {
      goToListingApp({ source: "dashboard", tab: "Admin Review" });
    } else if (message?.includes("Action Required! Uploading of product")) {
      goToListingApp({ source: "dashboard", tab: "In Draft" });
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const handlePageChange = (event, newPage) => {
    setServerPage(newPage);
  };

  // Reusable notification card renderer
  const renderNotificationCard = (notification, idx, eventName) => {
    const heading = getSafeTitle(notification);
    const messages = getSafeBody(notification);
    const maskedMessage = messages.replace(/productId:.*|poid:.*|piid:.*/g, "");

    if (loading) {
      return (
        <Skeleton
          key={idx}
          variant="rectangular"
          height={120}
          animation="wave"
          sx={{
            borderRadius: "12px",
            width: "100%",
          }}
        />
      );
    }

    return (
      <NotificationCard key={idx}>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: { xs: 1.5, sm: 2 },
            width: "100%",
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              flex: 1,
              minWidth: 0,
              width: "100%",
            }}
          >
            <Box
              sx={{
                height: "8px",
                width: "8px",
                borderRadius: "50%",
                backgroundColor: notification.read ? "transparent" : "#445FD2",
                flexShrink: 0,
                mt: 0.5,
              }}
            />
            <Avatargenerator
              width="60px"
              height="60px"
              minWidth="60px"
              minHeight="60px"
              maxWidth="60px"
              maxHeight="60px"
              companyname={userData?.data?.companyName}
              AvatarUrl={userData?.data?.CompanyAvatar?.url}
            />
            <Box
              sx={{
                flex: 1,
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
                gap: 0.5,
              }}
            >
              <Typography
                sx={{
                  fontFamily: '"Google Sans Flex", "Inter", sans-serif',
                  fontWeight: 500,
                  fontSize: "15px",
                  lineHeight: "22px",
                  color: "#2261a2",
                  textTransform: "capitalize",
                }}
              >
                {heading}
              </Typography>
              <Typography
                onClick={() => {
                  handleNotificationClick(notification);
                  sendEvents(eventName || "Click on message");
                }}
                sx={{
                  fontFamily: '"Google Sans Flex", "Inter", sans-serif',
                  fontWeight: 400,
                  fontSize: { xs: "12.8px", sm: "13.5px" },
                  lineHeight: { xs: "18px", sm: "20px" },
                  color: "#475569",
                  cursor: "pointer",
                  wordBreak: "break-word",
                  overflowWrap: "anywhere",
                  whiteSpace: "normal",
                  transition: "color 200ms cubic-bezier(0.22, 1, 0.36, 1)",
                  "&:hover": {
                    color: "#2261a2",
                  },
                }}
              >
                {maskedMessage}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "flex-end", sm: "flex-end" },
              gap: 0.35,
              flexShrink: 0,
              width: { xs: "100%", sm: "auto" },
              mt: { xs: 0.5, sm: 0 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "flex-end", sm: "center" },
                gap: 1,
              }}
            >
              <Button
                variant="text"
                onClick={() => {
                  UpdateNotifications(notification);
                  sendEvents("Click on mark as read or unread");
                }}
                sx={{
                  color: "#2563eb",
                  fontFamily: '"Google Sans Flex", "Inter", sans-serif',
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: "12.5px",
                  minWidth: "auto",
                  px: 1.25,
                  py: 0.4,
                  borderRadius: "999px",
                  transition: "all 180ms cubic-bezier(0.22, 1, 0.36, 1)",
                  "&:hover": {
                    backgroundColor: "rgba(183, 191, 217, 0.1)",
                  },
                  "&:active": {
                    transform: "translateY(1px)",
                  },
                  "&:focus-visible": {
                    outline: "2px solid #2563eb",
                    outlineOffset: "1px",
                  },
                }}
              >
                {notification.read === false
                  ? "Mark as Read"
                  : "Mark as Unread"}
              </Button>
              <CancelIcon
                onClick={() => {
                  DeleteNotifications(notification?._id);
                  sendEvents("Click on cancel");
                }}
                sx={{
                  color: "#9CA3AF",
                  fontSize: "18px",
                  cursor: "pointer",
                  transition: "all 180ms cubic-bezier(0.22, 1, 0.36, 1)",
                  "&:hover": {
                    color: "#EF4444",
                    transform: "scale(1.1)",
                  },
                  "&:active": {
                    transform: "scale(0.96)",
                  },
                }}
              />
            </Box>
            {formatNotificationReceivedAt(notification?.createdAt) ? (
              <Typography
                sx={{
                  fontFamily: '"Google Sans Flex", "Inter", sans-serif',
                  fontSize: "11px",
                  lineHeight: 1.3,
                  color: "#94a3b8",
                  pr: { xs: 0.5, sm: 4.5 },
                  whiteSpace: "nowrap",
                }}
              >
                {formatNotificationReceivedAt(notification?.createdAt)}
              </Typography>
            ) : null}
          </Box>
        </Box>
      </NotificationCard>
    );
  };

  useEffect(() => {
    setBtn1(active === "btn1");
    setBtn2(active === "btn2");
    setBtn3(active === "btn3");
    setBtn4(active === "btn4");
    setBtn5(active === "btn5");
  }, [active]);

  useEffect(() => {
    let activeBtnArray = [];

    if (btn1) {
      activeBtnArray = notifications;
    } else if (btn2) {
      // Match the header popup: older or generic notifications may not match
      // the BXI classifier, so don't show an empty page when the feed has rows.
      activeBtnArray = totalCountBXIArray.length
        ? totalCountBXIArray
        : notifications;
    } else if (btn3) {
      activeBtnArray = totalCountBuyerArray;
    } else if (btn4) {
      activeBtnArray = totalCountSellerArray;
    } else if (btn5) {
      activeBtnArray = readNotifications;
    }

    setBtns(activeBtnArray);
  }, [
    btn1,
    btn2,
    btn3,
    btn4,
    btn5,
    notifications,
    totalCountBXIArray,
    totalCountBuyerArray,
    totalCountSellerArray,
    readNotifications,
  ]);

  return (
    <>
      <BreadCrumbHeader MainText="Notifications" showbreadcrumb={true} />

      <Grid
        container
        sx={{
          background: "#FFFFFF",
          width: "100%",
          maxWidth: "800px",
          mx: "auto",
          borderRadius: "24px",
          boxShadow: "0 12px 40px rgba(18, 19, 23, 0.06)",
          border: "1px solid rgba(33, 34, 38, 0.06)",
        }}
      >
        <Grid
          item
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          sx={{
            mx: "auto",
            width: "100%",
            height: "100%",
            p: { xs: 2, sm: 3, md: 4 },
          }}
        >
          <Box
            sx={{
              width: "100%",
              mx: "auto",
              mb: 3,
            }}
          >
            {/* Header Row */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                mb: 0.5,
              }}
            >
              <IconButton
                onClick={() => navigate(-1)}
                sx={{
                  backgroundColor: "#efefef",
                  width: 40,
                  height: 40,
                  color: "#2261a2",
                  "&:hover": {
                    backgroundColor: "#e0e0e0",
                  },
                }}
              >
                <ArrowBackIosNewIcon sx={{ fontSize: { xs: 16, md: 18 } }} />
              </IconButton>

              <Typography
                sx={{
                  fontFamily: '"Google Sans Flex", "Inter", sans-serif',
                  fontSize: { xs: "16px", md: "28px" },
                  fontWeight: 500,
                  color: "#2261a2",
                  lineHeight: 1.2,
                }}
              >
                Notification Center
              </Typography>
            </Box>

            {/* Subtitle */}
            <Typography
              sx={{
                fontFamily: '"Google Sans Flex", "Inter", sans-serif',
                fontSize: "13px",
                color: "#64748b",
                mb: 3,
                ml: 6.5,
              }}
            >
              Track platform updates, transactions, and listing activity in one
              place.
            </Typography>

            <Box sx={ButtonGroupStyle}>
              {AuthUserData?.data?.superAdmin ||
                (AuthUserData?.data?.rightsarray?.SELLER?.includes?.(
                  "NOTIFICATIONS",
                ) &&
                  AuthUserData?.data?.rightsarray?.BUYER?.includes?.(
                    "NOTIFICATIONS",
                  )) ? (
                <StyledButton
                  active={active === "btn1"}
                  id="btn1"
                  onClick={() => {
                    setBtn1(true);
                    setBtn2(false);
                    setBtn3(false);
                    setBtn4(false);
                    setBtn5(false);
                    setServerPage(1);
                    setActive("btn1");
                    sendEvents("Click on all button");
                  }}
                >
                  All
                  {unReadCountOfAll > 0 && (
                    <Box
                      className="notification-count-badge"
                      sx={notificationcount}
                    >
                      {formatBadgeCount(unReadCountOfAll)}
                    </Box>
                  )}
                </StyledButton>
              ) : null}

              <StyledButton
                active={active === "btn2"}
                id="btn2"
                onClick={() => {
                  setBtn1(false);
                  setBtn2(true);
                  setBtn3(false);
                  setBtn4(false);
                  setBtn5(false);
                  setServerPage(1);
                  setActive("btn2");
                  sendEvents("Click on BXI button");
                }}
              >
                BXI
                {unReadCountOfBxi > 0 && (
                  <Box
                    className="notification-count-badge"
                    sx={notificationcount}
                  >
                    {formatBadgeCount(unReadCountOfBxi)}
                  </Box>
                )}
              </StyledButton>

              {AuthUserData?.data?.superAdmin ||
                AuthUserData?.data?.rightsarray?.BUYER?.includes?.(
                  "NOTIFICATIONS",
                ) ? (
                <StyledButton
                  active={active === "btn3"}
                  id="btn3"
                  onClick={() => {
                    setBtn3(true);
                    setBtn4(false);
                    setBtn2(false);
                    setBtn1(false);
                    setBtn5(false);
                    setServerPage(1);
                    setActive("btn3");
                    sendEvents("Click on Purchase button");
                  }}
                >
                  Purchase
                  {unReadCountOfBuyer > 0 && (
                    <Box
                      className="notification-count-badge"
                      sx={notificationcount}
                    >
                      {formatBadgeCount(unReadCountOfBuyer)}
                    </Box>
                  )}
                </StyledButton>
              ) : null}
              {AuthUserData?.data?.superAdmin ||
                AuthUserData?.data?.rightsarray?.SELLER?.includes?.(
                  "NOTIFICATIONS",
                ) ? (
                <StyledButton
                  active={active === "btn4"}
                  id="btn4"
                  onClick={() => {
                    setBtn3(false);
                    setBtn4(true);
                    setBtn2(false);
                    setBtn1(false);
                    setBtn5(false);
                    setServerPage(1);
                    setActive("btn4");
                    sendEvents("Click on sell button");
                  }}
                >
                  Sell
                  {unReadCountOfSeller > 0 && (
                    <Box
                      className="notification-count-badge"
                      sx={notificationcount}
                    >
                      {formatBadgeCount(unReadCountOfSeller)}
                    </Box>
                  )}
                </StyledButton>
              ) : null}

              <StyledButton
                active={active === "btn5"}
                id="btn5"
                onClick={() => {
                  setBtn1(false);
                  setBtn2(false);
                  setBtn3(false);
                  setBtn4(false);
                  setBtn5(true);
                  setServerPage(1);
                  setActive("btn5");
                  sendEvents("Click on Read button");
                }}
              >
                Read
                {readCount > 0 && (
                  <Box
                    className="notification-count-badge"
                    sx={notificationcount}
                  >
                    {formatBadgeCount(readCount)}
                  </Box>
                )}
              </StyledButton>
            </Box>
          </Box>

          <Box sx={{ mt: 3 }}>
            {(btn1 || btn2 || btn3 || btn4 || btn5) && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {btns?.length > 0 ? (
                  btns?.map((notification, idx) =>
                    renderNotificationCard(
                      notification,
                      idx,
                      btn2
                        ? "Click on BXI message"
                        : btn3
                          ? "Click on purchase message"
                          : btn4
                            ? "Click on sell message"
                            : btn5
                              ? "Click on read message"
                              : "Click on message",
                    ),
                  )
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: "400px",
                    }}
                  >
                    <Nodatafound />
                  </Box>
                )}
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
      {btn1 && btns?.length > 0 && serverTotalPages > 1 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 4,
            mb: 3,
            px: 2,
          }}
        >
          <StyledPagination
            count={serverTotalPages}
            page={serverPage}
            onChange={handlePageChange}
            showFirstButton
            showLastButton
          />
        </Box>
      )}
    </>
  );
};

export default FullscreenNotification;

const ButtonGroupStyle = {
  width: "100%",
  maxWidth: "800px",
  height: "auto",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: { xs: 1, sm: 1.5 },
  flexWrap: "wrap",
  my: 1,
  rowGap: { xs: 1, sm: 1.5 },
};

const notificationcount = {
  fontFamily: '"Google Sans Flex", "Inter", sans-serif',
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "10px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minWidth: "20px",
  height: "20px",
  backgroundColor: "rgba(183, 191, 217, 0.24)",
  color: "#2261a2",
  borderRadius: "999px",
  padding: "0 6px",
  marginLeft: "8px",
  lineHeight: 1,
};

